<template>
  <div class="concept-detail-page" :lang="$domLang">
    <v-sheet style="padding-bottom: 80px; position: relative">
      <v-sheet min-height="200">
        <!-- Premium Concept Description -->
        <PremiumConceptDesc v-if="concept" :concept="concept" :key="'premium-desc-' + componentKey" />

        <v-card flat class="px-0 py-4" v-if="options.content">
          <TipTapReader class="tiptap_style" :options="options" v-if="options.content" :key="componentKey" />
          <!-- <div v-else class="text-center font-weight-medium">입력 정보가 없습니다.</div> -->
        </v-card>
        <section v-if="publicReviewImages.length" class="public-review-gallery">
          <header class="review-header">
            <span class="review-label">REAL REVIEW</span>
            <div class="ornament-frame"><h2 class="review-concept-title">{{ concept.title }}</h2></div>
            <p class="review-heading">{{ reviewCopy.title }}</p>
            <p class="consent-strip">{{ reviewCopy.consent }}</p>
          </header>
          <div class="gallery-grid">
            <figure v-for="(photo, index) in publicReviewImages.slice(0, visibleReviewCount)" :key="photo" class="gallery-item">
              <img :src="photo" :alt="`${concept.title} ${reviewCopy.photo} ${index + 1}`" loading="lazy" decoding="async" />
            </figure>
          </div>
          <div v-if="visibleReviewCount < publicReviewImages.length" class="load-more-wrap">
            <button type="button" class="load-more-button" @click="visibleReviewCount += 9">{{ reviewCopy.more }}</button>
          </div>
        </section>
        <HtmlReader v-if="productType" :id="productType === 'premium' ? 'common-premium-desc' : 'common-desc'" :key="productType"></HtmlReader>
      </v-sheet>

      <!-- title -->
      <v-sheet>
        <div style="position: relative">
          <p class="text-center text-subtitle-1 text-md-h6 font-weight-medium title">{{ $t("page.conceptbooth.review-title") }}</p>
          <v-btn class="reviewBtn" style="position: absolute; bottom: 10px; right: 10px" small depressed @click="show_warning_dialog = true">{{ $t("button.review-write") }}</v-btn>
        </div>
        <div class="mt-1">
          <ReviewList :key="`review-${$route.params.conceptId}`" :conceptId="$route.params.conceptId" :hide-empty="publicReviewImages.length > 0" />
        </div>
      </v-sheet>

      <!-- <v-tabs v-model="tabs" color="primary" fixed-tabs class="mt-1">
        <v-tab v-for="item in tabItems" :key="item" class="text-subtitle-1 font-weight-medium">
          {{ item }}
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <ReviewList :conceptId="$route.params.conceptId" />
        </v-tab-item>
        <v-tab-item>
          <HtmlReader id="castle-concept-qna" />
        </v-tab-item>
      </v-tabs-items> -->
    </v-sheet>
    <ReviewWriteMoveGuideDialog @input="(e) => (show_warning_dialog = e)" @close="show_warning_dialog = false" @confirm="albumMove" :visible="show_warning_dialog" />

    <div class="floating-concept-actions" role="group" :lang="$domLang" :aria-label="actionCopy.groupLabel">
      <button type="button" class="concept-action-btn concept-action-btn--share" @click="askFriend">
        <v-icon class="concept-action-icon" aria-hidden="true">mdi-send-outline</v-icon>
        <span class="concept-action-copy">
          <span class="concept-action-title">{{ actionCopy.shareTitle }}</span>
          <span class="concept-action-subtitle">{{ actionCopy.shareSubtitle }}</span>
        </span>
      </button>

      <button type="button" class="concept-action-btn concept-action-btn--reserve" @click="goReserve">
        <span>{{ actionCopy.reserve }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import HtmlReader from "./components/HtmlReader"
import TipTapReader from "@/components/tiptap/Reader"
import ReviewList from "@/views/review/ReviewList"
import ReviewWriteMoveGuideDialog from "@/views/components/ReviewWriteMoveGuideDialog"
import PremiumConceptDesc from "./components/PremiumConceptDesc"
import htmlServce from "@/api/html-service"
import { mapState } from "vuex"

export default {
  components: {
    HtmlReader,
    TipTapReader,
    ReviewList,
    ReviewWriteMoveGuideDialog,
    PremiumConceptDesc,
  },

  data: () => ({
    show_warning_dialog: false,
    tabs: null,
    tabItems: ["공주들의 촬영" /*, "컨셉부스 QNA" */],

    concept: {},
    productType: null,
    publicReviewImages: [],
    visibleReviewCount: 9,

    //TipTap
    options: {
      content: "",
      readonly: true,
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,
  }),

  computed: {
    ...mapState(["lang"]),

    reviewTestMode() { return window.location.pathname.includes("_review_test") },

    reviewCopy() {
      if (this.lang === "en") return { title: "Memories of princesses who visited", consent: "Only actual shoot photos shared with customer consent are shown.", photo: "shoot photo", more: "View more" }
      if (this.lang === "jp") return { title: "先に訪れたプリンセスたちの記録", consent: "お客様の同意を得た実際の撮影写真のみ公開しています。", photo: "撮影写真", more: "もっと見る" }
      return { title: "먼저 다녀간 공주들의 기록", consent: "고객님의 동의를 받은 실제 촬영 사진만 공개합니다.", photo: "실제 촬영 사진", more: "더 보기" }
    },

    actionCopy() {
      if (this.lang === "en") {
        return {
          groupLabel: "Concept actions",
          shareTitle: "Would this suit me?",
          shareSubtitle: "Ask a friend",
          reserve: "Reserve",
        }
      }

      if (this.lang === "jp") {
        return {
          groupLabel: "コンセプトメニュー",
          shareTitle: "私に似合うかな？",
          shareSubtitle: "友だちに聞く",
          reserve: "予約する",
        }
      }

      return {
        groupLabel: "컨셉 메뉴",
        shareTitle: "이 컨셉, 나한테 어울려?",
        shareSubtitle: "친구에게 물어보기",
        reserve: "예약하기",
      }
    },
  },

  watch: {
    "$route.params.conceptId"() { this.load() },
    lang: function (val) {
      this.options.content = this.getContent()
      this.componentKey += 1
    },
  },

  mounted() {
    console.log(this.$route.params.conceptId)
    this.load()
  },
  methods: {
    load() {
      const conceptId = String(this.$route.params.conceptId)
      this.publicReviewImages = []
      this.visibleReviewCount = 9
      this.options.content = ""
      console.log("conceptId: " + conceptId)
      this.$http
        .post("/api/concept/select/specific", {
          params: {
            id: conceptId,
          },
        })
        .then(async (res) => {
          if (String(this.$route.params.conceptId) !== conceptId) return
          this.concept = res.data[0]
          this.productType = this.concept.productType || "makershot"
          console.log("productType: " + this.productType)
          if (this.productType === "premium") await this.loadPublicReview(conceptId)
          if (String(this.$route.params.conceptId) !== conceptId) return
          this.options.content = this.getContent()
          this.componentKey += 1
          //this.options.content = res.data[0].content
        })
    },

    loadPublicReview(conceptId) {
      const reviewApi = this.reviewTestMode ? "/api/public-reviews-test" : "/api/public-reviews"
      return this.$http.get(`${reviewApi}/${encodeURIComponent(conceptId)}`, { timeout: 10000 })
        .then(({ data }) => {
          if (String(this.$route.params.conceptId) !== conceptId) return
          const images = data && data.concept && data.concept.images
          this.publicReviewImages = Array.isArray(images) ? images : []
          if (data.automaticStatus === "unavailable") console.error("Automatic public reviews unavailable")
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) return
          console.error("Public review photos unavailable", error)
        })
    },

    albumMove() {
      this.show_warning_dialog = false
      this.$router.push("/mypage/home?type=picture")
    },

    getContent() {
      if (!this.concept) {
        return ""
      }

      const content = (this.lang === "jp" ? this.concept.content_jp : this.lang === "en" ? this.concept.content_en : null) || this.concept.content || ""
      if (!this.publicReviewImages.length) return content
      // Replace only legacy real-photo embeds after the shared gallery has loaded.
      // Keep the stored content and its fallback untouched when the API fails.
      const doc = new DOMParser().parseFromString(content, "text/html")
      doc.querySelectorAll("iframe[src]").forEach((frame) => {
        const url = new URL(frame.getAttribute("src"), window.location.origin)
        if (url.origin !== window.location.origin || !/^\/concept_list\/.*\/REAL_[^/]+\.html$/i.test(url.pathname)) return
        const wrapper = frame.parentElement
        frame.remove()
        if (wrapper.classList.contains("iframe-wrapper") && !wrapper.children.length && !wrapper.textContent.trim()) wrapper.remove()
      })
      return doc.body.innerHTML
    },

    async askFriend() {
      const url = window.location.href
      const title = this.concept?.title || document.title

      if (navigator.share) {
        try {
          await navigator.share({ title, url })
        } catch (error) {
          if (error && error.name !== "AbortError") {
            console.error("Concept share failed:", error)
          }
        }
        return
      }

      try {
        await navigator.clipboard.writeText(url)
        this.$toast.success(this.lang === "en" ? "Link copied." : this.lang === "jp" ? "リンクをコピーしました。" : "링크를 복사했습니다.")
      } catch (error) {
        window.prompt(this.lang === "en" ? "Copy this link" : this.lang === "jp" ? "リンクをコピーしてください" : "링크를 복사해 주세요", url)
      }
    },

    goReserve: _.debounce(function () {
      console.log("goReserve")
      // 예약하기 화면으로 이동 - conceptId와 event query 파라미터 전달
      const query = {
        conceptId: this.$route.params.conceptId,
      }

      // URL query param의 event 정보를 함께 전달
      if (this.$route.query.event) {
        query.event = this.$route.query.event
        // 컨셉 화면을 보고 온 손님: 예약 칸을 먼저 보이고 행사 소개는 그 아래로(10/17)
        query.bookingIntro = "after"
      }

      this.$router.push({
        path: "/booking/reserve",
        query: query,
      })
    }, 500),
  },
}
</script>
<style scoped>
.v-tab--active {
  color: black;
}
.title {
  border-bottom: 3px solid #8d75cb;
  height: 40px;
}

.reviewBtn {
  background-color: #9a80d1 !important;
  color: white !important;
  font-weight: 500;
  position: absolute;
  right: 10px;
  bottom: 10px;
  font-size: 17px !important;
  border: 1px solid grey;
  border-radius: 6px;
}

.concept-detail-page {
  --concept-body-font: "Pretendard Variable", "Noto Sans KR", sans-serif;
  --concept-display-font: "Cafe24Danjunghae", "Pretendard Variable", sans-serif;
}

.concept-detail-page:lang(ja) {
  --concept-body-font: "Noto Sans JP", sans-serif;
  --concept-display-font: "Noto Sans JP", sans-serif;
}

.public-review-gallery { width:100%; max-width:480px; margin:0 auto; background:#fff; font-family:var(--concept-body-font); }
.review-header { text-align:center; padding:24px 0 0; }
.review-label { display:block; color:#b58b48; letter-spacing:.24em; font-size:9px; font-weight:700; margin:0 0 6px; }
.ornament-frame { width:calc(100% - 20px); margin:0 auto; aspect-ratio:2.5/1; background:url('/concept_list/assets/lafia-real-gallery-frame.webp') center/100% 100% no-repeat; display:flex; align-items:center; justify-content:center; padding:22px 58px 6px; }
.review-concept-title { font-family:var(--concept-display-font); font-size:clamp(25px,7.6vw,36px); line-height:1.1; color:#7d303b; font-weight:400; margin:0; word-break:keep-all; overflow-wrap:break-word; }
.review-heading { font-family:var(--concept-display-font); font-size:clamp(19px,5.4vw,25px); line-height:1.35; color:#302522; margin:-2px 18px 14px; word-break:keep-all; }
.consent-strip { min-height:48px; margin:0; padding:11px 18px; background:#fff4f5; display:flex; align-items:center; justify-content:center; color:#6f6463; font-size:11px; line-height:1.45; word-break:keep-all; }
.gallery-grid { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:3px; width:100%; padding:3px 0 0; }
.gallery-item { width:100%; aspect-ratio:4/5; overflow:hidden; background:#f5f5f5; border-radius:5px; margin:0; }
.gallery-item img { width:100%; height:100%; display:block; object-fit:contain; }
.load-more-wrap { padding:18px 16px 16px; text-align:center; }
.load-more-button { min-height:44px; min-width:154px; padding:11px 25px; border:1px solid #c8a15a; border-radius:999px; background:#fff; color:#7d303b; font:inherit; cursor:pointer; }

.bottomFixedButton {
  max-width: 580px;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0px;
  padding-bottom: 10px;
  border-top: 1px solid #e0e0e0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.floating-concept-actions {
  position: fixed;
  z-index: 100;
  left: max(12px, calc(50% - 278px));
  right: max(12px, calc(50% - 278px));
  bottom: calc(40px + env(safe-area-inset-bottom));
  display: grid;
  grid-template-columns: minmax(0, 1.16fr) minmax(116px, 0.84fr);
  gap: 8px;
  max-width: 556px;
  margin: 0 auto;
  pointer-events: none;
}

.concept-action-btn {
  position: relative;
  display: flex;
  min-width: 0;
  height: 58px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 0;
  font-family: var(--concept-body-font);
  letter-spacing: 0;
  cursor: pointer;
  pointer-events: auto;
  clip-path: polygon(8px 0, calc(100% - 8px) 0, 100% 8px, 100% calc(100% - 8px), calc(100% - 8px) 100%, 8px 100%, 0 calc(100% - 8px), 0 8px);
  -webkit-tap-highlight-color: transparent;
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
}

.concept-action-btn::before {
  content: "";
  position: absolute;
  inset: 4px;
  z-index: -1;
  border: 1px solid currentColor;
  clip-path: inherit;
  opacity: 0.54;
}

.concept-action-btn:active {
  transform: translateY(1px) scale(0.985);
}

.concept-action-btn:focus-visible {
  outline: 3px solid rgba(239, 127, 171, 0.3);
  outline-offset: 3px;
}

.concept-action-btn--share {
  justify-content: flex-start;
  gap: 9px;
  padding: 0 14px;
  color: #6f5147;
  background: rgba(255, 253, 251, 0.96);
  border: 1px solid rgba(190, 143, 102, 0.72);
  box-shadow: 0 7px 18px rgba(92, 59, 49, 0.14), inset 0 0 0 1px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.concept-action-icon {
  flex: 0 0 auto;
  color: #be8f66 !important;
  font-size: 26px !important;
}

.concept-action-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
  text-align: left;
}

.concept-action-title,
.concept-action-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.concept-action-title {
  font-size: 13px;
  font-weight: 650;
  line-height: 1.2;
}

.concept-action-subtitle {
  color: #9b7165;
  font-size: 11px;
  font-weight: 450;
  line-height: 1.2;
}

.concept-action-btn--reserve {
  padding: 0 18px;
  color: white;
  background: linear-gradient(135deg, #f7a1ba 0%, #ef7fab 48%, #df6596 100%);
  border: 1px solid rgba(208, 91, 135, 0.86);
  box-shadow: 0 8px 20px rgba(213, 88, 135, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.5);
  font-family: var(--concept-display-font);
  font-size: 20px;
  font-weight: 400;
  line-height: 1;
}

.concept-action-btn--reserve::after {
  content: "";
  position: absolute;
  top: 7px;
  left: 14%;
  width: 44%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.82), transparent);
}

.floating-concept-actions:lang(ja) .concept-action-btn--reserve {
  font-weight: 500;
}

@media (max-width: 359px) {
  .floating-concept-actions {
    left: 8px;
    right: 8px;
    grid-template-columns: minmax(0, 1.22fr) minmax(104px, 0.78fr);
    gap: 6px;
  }

  .concept-action-btn--share {
    gap: 6px;
    padding: 0 9px;
  }

  .concept-action-icon {
    font-size: 23px !important;
  }

  .concept-action-title {
    font-size: 11px;
  }

  .concept-action-subtitle {
    font-size: 10px;
  }

  .concept-action-btn--reserve {
    padding: 0 10px;
    font-size: 18px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .concept-action-btn {
    transition: none;
  }
}
</style>
